// ============================================================================
// todo-client-mod -- useGroupMutations Hook
//
// 分组 CRUD mutations（创建/更新/删除分组）。
// 删除分组时 Todo 自动迁移到默认分组（由服务端处理）。
// ============================================================================
import { useState } from 'react';
import { getTodoApiClient } from '../todo-api-client.js';
/**
 * 分组 CRUD Mutations
 */
export function useGroupMutations() {
    const [creating, setCreating] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState(null);
    const createGroup = async (params) => {
        setCreating(true);
        setError(null);
        try {
            const result = await getTodoApiClient().createGroup(params);
            return result;
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '创建分组失败';
            setError(message);
            return null;
        }
        finally {
            setCreating(false);
        }
    };
    const updateGroup = async (id, params) => {
        setUpdating(true);
        setError(null);
        try {
            const result = await getTodoApiClient().updateGroup(id, params);
            return result;
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '更新分组失败';
            setError(message);
            return null;
        }
        finally {
            setUpdating(false);
        }
    };
    const deleteGroup = async (id) => {
        setDeleting(true);
        setError(null);
        try {
            await getTodoApiClient().deleteGroup(id);
            return true;
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '删除分组失败';
            setError(message);
            return false;
        }
        finally {
            setDeleting(false);
        }
    };
    const reset = () => {
        setCreating(false);
        setUpdating(false);
        setDeleting(false);
        setError(null);
    };
    return {
        creating,
        updating,
        deleting,
        error,
        createGroup,
        updateGroup,
        deleteGroup,
        reset,
    };
}
//# sourceMappingURL=use-group-mutations.js.map